import {
  EditorParamsApiKey,
  EditorAPIKey,
  LayoutApiKey,
  CompPointersApiKey,
} from '#packages/apis';
import { createComponentsApi } from './componentsWrapper';
import { ComponentsApiKey } from './publicApiKey';
import type { EntryPoint } from '#packages/apilib';

export const ComponentsEntrypoint: EntryPoint = {
  name: 'ComponentsApi',
  declareAPIs: () => [ComponentsApiKey],
  getDependencyAPIs: () => [
    EditorParamsApiKey,
    EditorAPIKey,
    LayoutApiKey,
    CompPointersApiKey,
  ],
  attach(shell) {
    shell.contributeAPI(ComponentsApiKey, () => createComponentsApi(shell));
  },
};

export type { ComponentsApi, ComponentsAddResult } from './componentsWrapper';
export type {
  ComponentAddedToStageData,
  AddPanelComponentAddedToStageByClick,
  AddPanelComponentAddedToStageByDrag,
} from './types';
